<template>
  <section class="container">
    <div class="learning">
      <div class="learning__tool">
        <div class="learning-tab">
          <el-radio-group
            v-model="CardOrListType"
          >
            <el-radio :label="'1'">
              <i class="fa fa-th-large" aria-hidden="true"></i>{{ $t('learning.view.grid') }}
            </el-radio>
            <el-radio :label="'2'">
              <i class="fa fa-list" aria-hidden="true"></i>{{ $t('learning.view.list') }}
            </el-radio>
          </el-radio-group>
        </div>

        <div class="learning-search">
          <el-input
            v-model="Args.keyWord"
            :placeholder="$t('learning.placeholder.searchCourse')"
            @keydown.enter="Search(0)"
          />
          <el-button @click="Search()">{{ $t('common.button.search') }}</el-button>
          <el-button @click="Search(1)">{{ $t('common.button.clear') }}</el-button>
        </div>
      </div>

      <div v-if="PageInfo.data.length" class="course">
        <ul v-if="CardOrListType === '1'" class="course__block">
          <li
            v-for="(item, index) in PageInfo.data"
            :key="index"
            class="course__item"
          >
            <div
              class="course__image"
              :style="{ 'background-image': `url(${ item.mainImagePath })` }"
            />

            <div class="course__content">
              <!-- <span class="course__tag">
                {{ item.courseTypeName }}
              </span> -->

              <p class="course__title">
                <span>{{ item.courseName }}</span>
              </p>

              <p class="course__date">
                <span><i class="fa fa-calendar" aria-hidden="true"></i>{{ $t('course.label.viewPeriod') }}</span>
                <span>
                  {{ item.courseViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
                  {{ item.courseViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                </span>
              </p>

              <div class="course__button">
                <button
                  class="course-button"
                  :class="{
                    'course-button--disable': !item.hasLook
                  }"
                  @click="goToClass(item)"
                >
                  {{ item.hasLook ? $t('learning.button.goToClass') : $t('learning.status.notAvailable') }}
                </button>

                <button
                  v-if="item.isExamAvailable"
                  class="course-button"
                  @click="GetGotoPractice(item.courseId)"
                >
                  {{ $t('learning.button.exam') }}
                </button>
              </div>
            </div>
          </li>
        </ul>

        <el-table
          v-if="CardOrListType === '2'"
          :data="PageInfo.data"
          border
        >
          <!-- <el-table-column
            prop="courseTypeName"
            label="類型"
            width="70"
            align="center"
          >
            <template slot-scope="scope">
              <span class="course__tag">{{ scope.row.courseTypeName }}</span>
            </template>
          </el-table-column> -->

          <el-table-column
            :label="$t('common.column.date')"
            width="200"
          >
            <template slot-scope="scope">
              {{ scope.row.courseViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
              {{ scope.row.courseViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
            </template>
          </el-table-column>

          <el-table-column
            prop="courseName"
            :label="$t('common.column.courseName')"
            min-width="200"
          />

          <el-table-column
            label=""
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div class="learning__actions">
                <el-button
                  v-if="scope.row.hasLook"
                  type="primary"
                  size="small"
                  @click="goToClass(scope.row)"
                >
                  {{ $t('learning.button.goToClass') }}
                </el-button>

                <a v-else class="learning__button-disabled" @click.prevent>
                  {{ $t('learning.status.notAvailable') }}
                </a>

                <el-button
                  v-if="scope.row.isExamAvailable"
                  type="primary"
                  size="small"
                  @click="GetGotoPractice(scope.row.courseId)"
                >
                  {{ $t('learning.button.exam') }}
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination pagination--center">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :current-page.sync="Pagination.pageIndex"
            :page-size="Pagination.pageSize"
            :total="PageInfo.count"
            @current-change="GetList()"
          />
        </div>
      </div>

      <div v-else class="error-bg" >
        <p>{{ $t('learning.message.noData') }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import { GetGotoClass } from '@/api/OrderApi';

export default {
  data() {
    return {
      Args: { keyWord: '' },
      Pagination: {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 9, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      },
      PageInfo: {
        count: 0, // api給的總筆數
        data: [],
      },
      CardOrListType: '1', // 設定在哪種清單模式 1圖示(好看) 2清單(醜醜)
    };
  },
  // 當有設定keep的時候，返回到此頁面會執行這個，不會執行created()，所以這邊就不用放created()
  async activated() {
    const myStorage = window.localStorage;
    this.CardOrListType = myStorage.getItem('LearningsListType') !== null
      ? myStorage.getItem('LearningsListType')
      : '1';
    if (!this.$route.meta.isBack) {
      // 不是從指定頁面返回的話，進行初始化設定
      this.Args = { keyWord: '' };
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 9, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      };
      this.PageInfo = {
        count: 0, // api給的總筆數
        data: [],
      };
    }
    // 然後再針對頁面進行初始化資料存取
    this.GetList();
  },
  methods: {
    Search(isClear = 0) {
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 9, // 預設每頁幾筆
        data: {
          keyWord: '',
        },
      };
      if (isClear === 0) this.Pagination.data = { ...this.Args };
      if (isClear === 1) this.Args = { keyWord: '' };
      this.GetList();
    },
    GetList() {
      this.Pagination.data = { ...this.Args };
      GetGotoClass(this.Pagination).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfo.count = response.data.count;
          this.PageInfo.data = response.data.data;
          if (this.Pagination.pageIndex !== 1 && this.PageInfo.data.length === 0) {
            this.Pagination.pageIndex = 1;
            this.GetList();
          }
        }
      });
    },
    CardOrList() {
      const myStorage = window.localStorage;
      myStorage.setItem('LearningsListType', this.CardOrListType);
    },
    goToClass(item) {
      if (!item.hasLook) {
        return;
      }

      this.$router.push({ path: `/learnings/${item.courseId}` });
    },
    GetGotoPractice(courseId) {
      this.$router.push({ path: `/practices/${courseId}` });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.learning {
  /deep/ .el-table {
    margin-bottom: 24px;

    .course__tag {
      position: static;
      margin: 0;
    }

    .el-table__header th {
      background-color: var(--background-base);
      color: var(--text-primary);
      font-weight: 600;
      font-size: var(--font-size-sm);
    }

    .el-table__row {
      transition: background-color var(--transition-fast);

      &:hover {
        background-color: var(--primary-light-color);
      }
    }

    &.el-table--border,
    &.el-table--group {
      border: none;
    }

    .el-table__body-wrapper {
      border-radius: var(--border-radius-base);
    }
  }

  &__actions {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  &__button-disabled {
    display: inline-block;
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: var(--text-secondary);
    background-color: var(--background-base);
    border: 1px solid var(--border-light);
    cursor: not-allowed;
    text-decoration: none;
    line-height: 1;
  }

  &__tool {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 50px;
  }

  &-tab {
    @media (max-width: 991px) {
      width: 100%;
      margin-top: 20px;
      order: 1;
    }

    /deep/ .el-radio {
      margin-right: 10px;

      &__input {
        display: none;
      }

      &__label {
        display: block;
        width: 100%;
        padding: 12px 16px;
        font-size: 16px;
        font-weight: 500;
        border: 1px solid #ddd;
        border-radius: 10px;

        i {
          margin-right: 4px;
        }
      }

      &.is-checked {
        .el-radio__label {
          color: var(--custom-color);
          background-color: var(--custom-light-color);
          border-color: var(--custom-color);
          border: none;
        }
      }
    }
  }

  &-search {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding: 5px 12px;

    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;

    @media (max-width: 991px) {
      order: 0;
      width: 100%;
    }

    &:focus-within {
      border-color: #777;
    }

    ::v-deep .el-input {
      margin-right: 8px;
      max-width: 200px;

      @media (max-width: 991px) {
        max-width: 100%;
        margin-left: 8px;
      }

      &__inner {
        height: 28px;
        padding: 2px;

        line-height: 28px;
        font-size: 15px;
        color: #667085;

        border: none;

        &::placeholder {
          font-size: 14px;
          color: #c9c6c6;
        }
      }
    }

    ::v-deep .el-button {
      padding: 7px 12px;
      line-height: 1;
      color: var(--primary-color);
      background-color: #fff;
      border: none;
      border-radius: 4px;
      background-color: var(--primary-light-color);
      opacity: .8;

      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
